import { useQuery } from '@tanstack/react-query'
import { ResultOf } from 'gql.tada'
import { useEffect, useState } from 'react'
import { QueryKeys, getApiUrl } from './utils'
import { activeCustomerFragment } from './vendure/fragments/active-customer'

/**
 * Modified from link below
 * @see https://observablehq.com/@werehamster/avoiding-hydration-mismatch-when-using-react-hooks
 * @param mediaQueryString
 * @returns {unknown}
 */
export function useBetterMediaQuery(mediaQueryString: string) {
  const [matches, setMatches] = useState<boolean>()

  useEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQueryString)
    const listener = () => setMatches(!!mediaQueryList.matches)
    listener()
    mediaQueryList.addEventListener('change', listener) // updated from .addListener
    return () => mediaQueryList.removeEventListener('change', listener) // updated from .removeListener
  }, [mediaQueryString])

  return matches
}

export const useActiveCustomer = () =>
  useQuery({
    queryKey: QueryKeys.activeCustomer,
    queryFn: async () => {
      const res = await fetch(getApiUrl('/api/user'))
      const body = await res.json()
      return body.user as ResultOf<typeof activeCustomerFragment> | null
    },
  })
